export const TRACK_REQUEST: string = 'REDUX_REQUEST_TRACK_REQUEST';
export const RESOLVE_REQUEST: string = 'REDUX_REQUEST_RESOLVE_REQUEST';



// WEBPACK FOOTER //
// ./src/constants.ts